/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Nav Default Currency
 */
export type UpdateMetadataRequestNavDefaultCurrency = typeof UpdateMetadataRequestNavDefaultCurrency[keyof typeof UpdateMetadataRequestNavDefaultCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMetadataRequestNavDefaultCurrency = {
  HKD: 'HKD',
  USD: 'USD',
} as const;
